import { postFormData, jump, initJump } from '../../02-tools/index'

let el
let container
let form
let results

export function SearchDirectory() {
    el = document.querySelector('.js-search-directory')
    if (!el) {
        return
    }

    container = el.querySelector('.js-search-directory-search-container')
    form = el.querySelector('.js-search-directory-form')
    results = el.querySelector('.js-search-directory-results')

    initJump()

    form.addEventListener('submit', formSubmit)
}

function error() {
    return `
    <div class="c-search-directory__results-description">
        <h2 class="js-search-directory-title">No results were found based on your search</h2>
    </div>
    `
}

function anchorSubmit(evt) {
    const url = evt.currentTarget.href
    ajaxSubmit(evt, url)
}

function formSubmit(evt) {
    const url = form.action
    ajaxSubmit(evt, url)
}

function ajaxSubmit(evt, url) {
    evt.preventDefault()

    const formData = new FormData(form)

    postFormData(url, formData)
        .then((data) => JSON.parse(data))
        .then((data) => {
            removeResultEventListeners()
            if (data.success) {
                update(data.data.html)
                addResultEventListeners()
                return
            }

            console.error(data.message)
            update(error())
        })
        .catch((data) => {
            console.error(data)
            update(error())
        })
}

function update(html) {
    results.innerHTML = html

    container.dataset.active = true
    results.dataset.active = true
    jump(results)
}

function removeResultEventListeners() {
    getPaginationAnchors().forEach((anchor) => anchor.removeEventListener('click', anchorSubmit))
}

function addResultEventListeners() {
    getPaginationAnchors().forEach((anchor) => anchor.addEventListener('click', anchorSubmit))
}

function getPaginationAnchors() {
    const pagination = results.querySelector('.js-numbered-pagination')

    if (!pagination) {
        return []
    }

    return pagination.querySelectorAll('a') || []
}
